import React from 'react';

import 'css!./__styles__/OptionFeedbackTable';

class OptionFeedbackTable extends React.LegacyComponentWithChildren {
  static propTypes = {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
    children: React.PropTypes.node,
  };

  render() {
    return (
      <table className="rc-OptionFeedbackTable">
        <tbody>{this.props.children}</tbody>
      </table>
    );
  }
}

export default OptionFeedbackTable;
